import { Col, Container, Row, Stack } from 'react-bootstrap'
import { Tooltip } from '../Tooltip/Tooltip'
import { Button } from '../Button/Button'
import React from 'react'
import { MissingScopeAction } from '../ScopedBlock/models'
import { ScopedBlock } from '../ScopedBlock/ScopedBlock'
import { useSessionAvailability } from '../ScopedBlock/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import './MeetingTools.scss'

export const InPersonTool = () => {
  const { available: sessionAvailable, isSuccess: sessionAvailabilitySuccess } = useSessionAvailability()
  const navigate = useNavigate()
  const atRoomSessionLimitActions = () => {
    return sessionAvailabilitySuccess && sessionAvailable
  }
  const { pathname } = useLocation()

  const handleStartClicked = () => {
    navigate(`/workspace/in-person-meeting/${pathname.includes('live-meetings') ? 'live-meetings' : 'upcoming'}`)
  }

  return (
    <Container className='d-flex flex-column gap-4 justify-content-between h-100 p-0'>
      <Row>
        <Col xs='auto' className='gx-3'>
          <div className='flex rounded integration-icon-wrapper'>
            <i className='bi bi-laptop '></i>
          </div>
        </Col>
        <Col>
          <h5>In Person Meeting</h5>
          <div className='paragraph-medium zocks-text-gray-600'>Focus on your clients while Zocks captures detailed notes.</div>
          <div className='paragraph-medium zocks-text-gray-600'>
            Zocks sets the industry standard with unmatched accuracy, formatting precision, configurability, and security, without recordings.
          </div>
        </Col>
      </Row>
      <Row>
        <Container className='upcoming-integration-bottom-box'>
          <Row className='align-items-center'>
            <Col>
              <div className='paragraph-small zocks-text-gray-600 align-content-center label-container'>Available on mobile too</div>
            </Col>
            <Col xs='auto' className='flex align-items-center justify-content-end'>
              <Stack direction='horizontal' gap={2}>
                <Tooltip title='Android' placement='top'>
                  <i className='bi bi-android2 provider-logo android' />
                </Tooltip>
                <Tooltip title='Apple' placement='top'>
                  <i className='bi-apple provider-logo apple' />
                </Tooltip>
              </Stack>
            </Col>
          </Row>
          <Row className='d-flex align-items-center m-0'>
            <Col className='d-flex justify-content-end p-0'>
              <ScopedBlock
                scope={{
                  scope: 'room_session:start',
                  superScope: ['room_session:admin', 'room:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <ScopedBlock authActions={[atRoomSessionLimitActions]} missingScopeAction={MissingScopeAction.DISABLE}>
                  <Button variant='primary' className='w-100 px-0' onClick={handleStartClicked}>
                    Create In Person Meeting
                  </Button>
                </ScopedBlock>
              </ScopedBlock>
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  )
}
